import React from "react";
import Header from "../components/Header";
import ImageGallery from "react-image-gallery";
import { motion } from "framer-motion";
import "react-image-gallery/styles/css/image-gallery.css";
import "../styles/Casa.css";

import IconUaiThai from "../assets/iconUaiThai.png"; // usa o mesmo da home
import Footer from "../components/Footer";

import casaImages from "../assets/casa";

const Casa = () => {
    
    const images = casaImages.map((img) => ({
        original: img,
        thumbnail: img,
    }));

    return (
        <>
            <Header />

            <section className="casa-intro">
                <motion.div
                    className="casa-intro-container"
                    initial={{ opacity: 0, y: 40 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                >
                    <h2>
                        UaiThai Tiradentes
                    </h2>

                    <div className="divider">
                        <hr />
                        <img src={IconUaiThai} alt="Ícone UaiThai" />
                        <hr />
                    </div>

                    <p>
                        Localizado no coração de Tiradentes, o <strong>UaiThai</strong> é mais do que
                        um restaurante — é um refúgio sensorial que une o charme mineiro à
                        essência tailandesa.
                    </p>

                    <p>
                        Cada detalhe da casa foi pensado para transmitir acolhimento e
                        sofisticação: arquitetura contemporânea, iluminação suave e o
                        aroma marcante das especiarias que preenchem o ar.
                    </p>

                    <p>
                        Um lugar onde tradição e modernidade se encontram, criando uma
                        experiência inesquecível para os cinco sentidos.
                    </p>
                </motion.div>
            </section>

            <motion.section
                className="casa-gallery"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ duration: 1 }}
            >
                <h1>Conheça a Casa</h1>
                <p>
                    Explore os ambientes e descubra o equilíbrio entre cultura, natureza
                    e conforto.
                </p>

                <div className="gallery-wrapper">
                    <ImageGallery
                        items={images}
                        showPlayButton={false}
                        showFullscreenButton={true}
                        lazyLoad={true}
                        autoPlay={true}
                    />
                </div>
            </motion.section>


            <Footer />
        </>
    );
};

export default Casa;
